import React from 'react';
import { Navigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import PortalLayout from '@/components/portal/PortalLayout';

// Schützt Routen, die nur Mitarbeitern der Hausverwaltung (admin/mitarbeiter) zugänglich sein dürfen.
export const StaffRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;

  let user = {};
  try { user = JSON.parse(localStorage.getItem('user') || '{}'); } catch { user = {}; }
  const isStaff = user.role === 'admin' || user.role === 'mitarbeiter';

  if (!isStaff) {
    return (
      <PortalLayout>
        <div className="flex items-center justify-center py-24 px-4" data-testid="staff-route-no-access">
          <div className="max-w-md text-center bg-white border border-gray-100 rounded-2xl shadow-sm p-8">
            <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-7 h-7 text-red-500" />
            </div>
            <h1 className="font-heading text-2xl text-brand-navy mb-2">Kein Zugriff</h1>
            <p className="text-gray-500 text-sm mb-6">Dieser Bereich steht nur Mitarbeitern der Hausverwaltung zur Verfügung.</p>
            <a href="/portal/dashboard" className="inline-block px-5 py-2.5 bg-brand-navy text-white rounded-lg text-sm font-medium hover:bg-brand-navy/90 transition-colors" data-testid="staff-route-back-btn">Zurück zum Dashboard</a>
          </div>
        </div>
      </PortalLayout>
    );
  }

  return children;
};

export default StaffRoute;
